import { createDynamicThunk } from ".";

export const getExpenseCodeListThunk = createDynamicThunk({
  typePrefix: "expenseCodes/getExpenseCodeListThunk",
  useHandleSearch: true,
});

export const addExpenseCodeThunk = createDynamicThunk({
  typePrefix: "expenseCodes/addExpenseCodeThunk",
  endpoint: "/expense-code",
  method: "POST",
  refreshList: true,
  listThunk: getExpenseCodeListThunk,
});

export const editExpenseCodeThunk = createDynamicThunk({
  typePrefix: "expenseCodes/editExpenseCodeThunk",
  endpoint: "/expense-code",
  method: "PUT",
  refreshList: true,
  listThunk: getExpenseCodeListThunk,
  transformResponse: (response) => response,
});

export const deleteExpenseCodeThunk = createDynamicThunk({
  typePrefix: "/deleteExpenseCodeThunk",
  endpoint: "/softDeleteMul",
  method: "POST",
  refreshList: true,
  listThunk: getExpenseCodeListThunk,
});
